// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__v98qa","warning_icon":"style_warning_icon__Kjp7D","text":"style_text__SJERX","paragraph":"style_paragraph__T6TVv","link":"style_link___WhOY"};